import { Injectable , Inject} from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable , throwError  } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { APIService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class VacanciesService extends APIService{
  constructor(http: HttpClient,router :Router) {
    super(http)
    this.endPoint = "vacancies"
  }
  
  getAll(skip=0,limit=null){
    var query = ''
    if(limit)
      query = `?skip=${skip}&limit=${limit}`;
    return this.http.get(this.url+`/active/`+query,this.httpOptions)
  }

  get(id){
  	return this.http.get(this.url+`/active/${id}`,this.httpOptions)
	}

  add(record){
    return this.http.post(this.url,record,this.httpOptions)
  }

  update(record,id){
    return this.http.put(this.url+`/${id}`,record,this.httpOptions);
  }

  delete(id){
    return this.http.delete(this.url+`/${id}`,this.httpOptions);
  }

  getByJobID(job_id){
    return this.http.get(this.url+`/job/${job_id}`,this.httpOptions)
  }
}
